exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.font-s[data-v-cfcb22be] {\n  font-size: 12px;\n  font-weight: normal;\n  color: #bbb;\n}\n", ""]);

// exports
